export default __webpack_public_path__ + "b3b26de39d35bbe711f6c06487247f1f.png";